import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link} from 'react-router-dom';


const MakerSpace = () =>{
  
  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/explore.jpg" alt="" />
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
          <div className='information-content'>
            <h2>Using the Library/Explore</h2>
            <p>The following collaborative spaces are available at the library.</p>
          </div>
          <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                        <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/CollaborativeWorkingAndLearningSpaces" className='nav-link'>
                                    Collaborative Working and Learning Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerAndTechnology" className='nav-link'>
                                    Computer And Technology
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/PrintingScanningAndPhotocopying" className='nav-link'>
                                    Printing Scanning And Photocopying
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibraryService" className='nav-link active'>
                                    Library Service
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/MakerSpace" className='nav-link '>
                                    Maker Space
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="collaboration-hover">
                    <img className="img-fluid" src="./assets/img/learningspaces/library-space.jpg" alt="" />
                    <p>Habib University’s library team aims to provide students with adequate facilities for learning with passion. With a range of library and learning services available, it creates an environment that supports teaching, learning, and research. The library provides a stimulating user-centered environment, learning spaces, and customer services supported by digital technologies.</p>
                    <Link as={Link} to="/LibraryServices" className='btn-dfault'>
                    View All Library Services
                                    </Link>
                </div>
                </Col>
            </Row>
        </div>
      </section>


    </div>
  );
}
export default MakerSpace;